module.exports = __webpack_public_path__ + "img/headerLogo.975b47d6.png";